import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { applyPacienteInmunoterapiaAplicacion } from "../services/inmunoterapia.service";

import { dangerNotification, successNotification } from '../../../redux/slices/ui';

export const usePacienteInmunoterapiaAplicacionAplicar = (id) => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const applyInmunoterapiaAplicacionMutation = useMutation({
        mutationFn: applyPacienteInmunoterapiaAplicacion,
        onSuccess: ({inmunoterapia, aplicacion, notificacion, msg, caducidad, limite}, variables, context) => {
            if(notificacion){
                variables.notificacion(msg);
            }else if(caducidad){
                variables.caducidad();
            }else if (limite){
                variables.limite();
            }else{
                variables.resetAccion();
                queryClient.invalidateQueries({ queryKey: ['paciente/inmunoterapia/proxima', id] });
                variables.success(inmunoterapia.aplicaciones);
                dispatch(successNotification('Inmunoterapia ' + ((inmunoterapia.aplicaciones.find(app => String(app._id) === String(aplicacion)).realizado) ? 'aplicada' : 'pendiente')));
            }
        },
        onError: (error, variables, context) => {
            // console.log(error);
            dispatch(dangerNotification(error.message));
            variables.error();
        },
    });

    return {
        applyInmunoterapiaAplicacionMutation,
    }
}